import React, { useState } from "react";
import Forget from "../../assets/others/reset.jpg";
import { useMakeRequest } from "../../hooks/useMakeRequest";
import { AUTH_URL } from "../../constant/resource";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { CgSpinner } from "react-icons/cg";
// import { BsEye } from "react-icons/bs";
// import { TbEyeCancel } from "react-icons/tb";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { toast } from "sonner";

interface IForget {
  email: string;
  password: string;
}

const ForgetPassword = () => {
  const [formData, setFormData] = useState<IForget>({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const makeRequest = useMakeRequest();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e?.target?.name]: e?.target?.value });
  };
  const email = searchParams.get("email");
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    const payload = { ...formData, email: email as string };
    makeRequest(
      AUTH_URL,
      "PUT",
      payload,
      (data) => {
        toast.success(data?.message);
        navigate("/login");
      },
      (error) => {
        console.log(error);
      },
      () => setLoading(false)
    );
  };
  return (
    <div className="w-screen h-screen flex items-center justify-center sm:p-20 p-2 bg-gray-200">
      <div className="flex sm:flex-row flex-col sm:w-[80%] w-full py-10 bg-white sm:p-10 rounded-md items-center justify-center gap-10">
        <div className="sm:w-1/2">
          <img
            className="sm:w-3/4 w-[200px] object-cover"
            src={Forget}
            alt="forget password background"
          />
        </div>
        <div className="flex flex-col items-start justify-start">
          <h1 className="font-bold sm:text-2xl text-xl sm:mb-10 mb-5 text-gray-500">
            Reset your password
          </h1>
          <form
            className="flex flex-col items-start justify-start"
            onSubmit={handleSubmit}
          >
            <label className="text-gray-600 sm:mb-2" htmlFor="password">
              Enter new password
            </label>
            <div className="bg-gray-200 p-2 flex items-center justify-center px-4 outline-none shadow-sm border">
              <input
                className="bg-inherit outline-none"
                required
                onChange={handleChange}
                type={showPassword ? "text" : "password"}
                placeholder="*********"
                name="password"
              />
              {showPassword ? (
                <FaRegEyeSlash
                  className="cursor-pointer"
                  onClick={() => {
                    setShowPassword(false);
                  }}
                />
              ) : (
                <FaRegEye
                  className="cursor-pointer"
                  onClick={() => {
                    setShowPassword(true);
                  }}
                />
              )}
            </div>
            <button
              className="mt-2 bg-red-400 p-2 px-4 ronded-md shadow-md text-white"
              type="submit"
            >
              {loading ? (
                <CgSpinner className="w-4 h-4 animate-spin" />
              ) : (
                "Submit"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
